import getFirstSubtestId from "../../nav/getFirstSubtestId";

// generates the links for the AssessSelectorNav component
export default function getAssessSelectorNavLinks (
  selectedGroupUA,
  isStudent,
  selectedStudent,
  role,
  userAssessment,
  assessmentId,
  groupUA,
  activeSubtest,
  year
) { 
  // Create the overview link
  let overviewQuery = ''
  let yearQuery = ''
  
  if(year) yearQuery = `&y=${year}`

  if (selectedGroupUA && !isStudent) {
    overviewQuery = `?gua=${selectedGroupUA}${yearQuery}`
  }
  if (selectedGroupUA && selectedStudent) {
    overviewQuery = `?gua=${selectedGroupUA}&s=${selectedStudent}${yearQuery}`
  }

  // find the index 0 subtest to create the links
  let firstSubtestId
  let skillReportLink = ''
  let itemReportLink = ''
  if (role === 'Student' && userAssessment) {
    firstSubtestId = getFirstSubtestId(userAssessment)
    if (activeSubtest) {
      firstSubtestId = activeSubtest
    }
    skillReportLink = `/assessment/reports/${userAssessment.userAssessmentId}/${firstSubtestId}${year ? '?y='+ year : ''}`
    itemReportLink = `/assessment/testing/${userAssessment.userAssessmentId}/${firstSubtestId}?item=overview${yearQuery}`
  } else if (selectedStudent) {
    firstSubtestId = getFirstSubtestId(groupUA)
    if (activeSubtest) {
      firstSubtestId = activeSubtest
    }
    let studentQuery = ''
    if (selectedStudent) {
      studentQuery = `&s=${selectedStudent}`
    }
    skillReportLink = `/assessment/reports/${selectedGroupUA}/${firstSubtestId}/?g=true&a=${assessmentId}${studentQuery, yearQuery}`
    itemReportLink = `/assessment/testing/${selectedGroupUA}/${firstSubtestId}?item=overview&g=true&a=${assessmentId}${studentQuery, yearQuery}`
  } else if (groupUA) {
    firstSubtestId = getFirstSubtestId(groupUA)
    if (activeSubtest) {
      firstSubtestId = activeSubtest
    }
    let studentQuery = ''
    if (selectedStudent) {
      studentQuery = `&s=${selectedStudent}`
    }
    skillReportLink = `/assessment/reports/${selectedGroupUA}/${firstSubtestId}/?g=true&a=${assessmentId}${studentQuery, yearQuery}`
    itemReportLink = `/assessment/testing/${selectedGroupUA}/${firstSubtestId}?item=overview&g=true&a=${assessmentId}${studentQuery, yearQuery}`
  }

  return {
    overviewLink: `/assessment/dashboard/${assessmentId}${overviewQuery}`,
    skillReportLink,
    itemReportLink,
  }
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/assessmentDashboard/getAssessSelectorNavLinks.js